import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ResponseType = paths['/v3/transaction_items']['get']['responses']['200']['content']['application/json'];
type TransactionsRequestParams = paths['/v3/transaction_items']['get']['parameters']['query'];

export const getTransactionItems = async ({ config: { params } }: ConfigRequest<TransactionsRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.transactions.items, {
    params,
  });
